export default __webpack_public_path__ + "static/media/burger.b0307f18.svg";